export default "__VITE_ASSET__4Hew8pY5__"